import React, { useState, useEffect } from "react";
import { db, collection, addDoc, getDocs, deleteDoc, doc, updateDoc } from "../firebase";
import { Container, Form, Button, Table, Modal, Row, Col } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import default styles



const AdminPanel = () => {
  const [blogs, setBlogs] = useState([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("");
  const [date, setDate] = useState("");
  const [tags, setTags] = useState([]);
  const [editBlog, setEditBlog] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    const fetchBlogs = async () => {
      const querySnapshot = await getDocs(collection(db, "blogs"));
      setBlogs(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchBlogs();
  }, []);

  const handleAddBlog = async (e) => {
    e.preventDefault();
    if (!title || !content || !author || !date || !tags.length) return;
    await addDoc(collection(db, "blogs"), {
      title,
      content,
      author,
      date,
      tags: tags.split(",").map(tag => tag.trim()),
    });
    setShowAddModal(false);
    window.location.reload();
  };

  const handleUpdateBlog = async () => {
    if (!editBlog) return;
    await updateDoc(doc(db, "blogs", editBlog.id), {
      title,
      content,
      author,
      date,
      tags: tags.split(",").map(tag => tag.trim()),
    });
    setShowEditModal(false);
    window.location.reload();
  };

  const handleEditBlog = (blog) => {
    setEditBlog(blog);
    setTitle(blog.title);
    setContent(blog.content);
    setAuthor(blog.author);
    setDate(blog.date);
    setTags(Array.isArray(blog.tags) ? blog.tags.join(", ") : "");
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "blogs", id));
    setBlogs(blogs.filter((blog) => blog.id !== id));
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-4">Admin Panel - Manage Blogs</h2>
      <Button variant="success" className="mb-3" onClick={() => setShowAddModal(true)}>+ Add Blog</Button>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Title</th>
            <th>Author</th>
            <th>Date</th>
            <th>Tags</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((blog) => (
            <tr key={blog.id}>
              <td>{blog.title}</td>
              <td>{blog.author}</td>
              <td>{blog.date}</td>
              <td>{Array.isArray(blog.tags) ? blog.tags.join(", ") : "N/A"}</td>
              <td>
                <Button variant="warning" onClick={() => handleEditBlog(blog)}>Edit</Button>
                <Button variant="danger" onClick={() => handleDelete(blog.id)} className="ms-2">Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Add Blog Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleAddBlog}>
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Title</Form.Label>
                  <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
              <Form.Group>
                <Form.Label>Content</Form.Label>
                <ReactQuill theme="snow" value={content} onChange={setContent} />
              </Form.Group>

              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Author</Form.Label>
                  <Form.Control type="text" value={author} onChange={(e) => setAuthor(e.target.value)} required />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Date</Form.Label>
                  <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>Tags (comma-separated)</Form.Label>
                  <Form.Control type="text" value={tags} onChange={(e) => setTags(e.target.value)} required />
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" variant="primary">Add Blog</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Blog Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Title</Form.Label>
              <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
            </Form.Group>
            <Form.Group>
              <Form.Label>Content</Form.Label>
              <ReactQuill theme="snow" value={content} onChange={setContent} />
            </Form.Group>

            <Form.Group>
              <Form.Label>Author</Form.Label>
              <Form.Control type="text" value={author} onChange={(e) => setAuthor(e.target.value)} required />
            </Form.Group>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
            </Form.Group>
            <Form.Group>
              <Form.Label>Tags (comma-separated)</Form.Label>
              <Form.Control type="text" value={tags} onChange={(e) => setTags(e.target.value)} required />
            </Form.Group>
            <Button onClick={handleUpdateBlog} variant="success" className="mt-3">Update Blog</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AdminPanel;
